module.exports = __webpack_public_path__ + "mv.a8ff2cc66e05787e371d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/mv.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/mv.svg
// module chunks = styles